import styled from 'styled-components';

const IconContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
`;

const IconTextOverlay = styled.div`
  position: absolute;
  font-size: 5px;
  top: 55%;
  left: 18%;
  width: 1em;
  height: 1em;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  mix-blend-mode: difference;
`;

export default {
  IconContainer,
  IconTextOverlay,
};
